/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, Output, OnChanges, Input, EventEmitter, ViewEncapsulation, ViewChild, SimpleChanges, AfterViewInit } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import { NgForm } from '@angular/forms';
import { COMPANY_CODES } from '../../config/constants';
import moment from 'moment';
import { PlanPeriodsService } from '../../shared/services/planperiods.service';
import { ChangeSponsorService } from '../changesponsor/change-sponsor.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ChangeParentOrganizationConfirmationModalComponent } from './change-parent-organization-confirmation-modal.component';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-change-parent-organization',
  templateUrl: './change-parent-organization.component.html',
  styleUrls: ['./change-parent-organization.component.scss'],
  providers: [ChangeSponsorService],
  encapsulation: ViewEncapsulation.None
})
export class ChangeParentOrganizationComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('orgParentUnitForm') orgParentUnitForm!: NgForm;
  @Output() closeSlider: EventEmitter<any> = new EventEmitter();
  @Input() organization: any;
  private currentDate: Date = new Date();
  private globalDateFormatVar: any = localStorage.getItem('globalDateFormat');
  public datePickerOptions: Partial<BsDatepickerConfig> = {
    dateInputFormat: this.globalDateFormatVar
      ? this.globalDateFormatVar.toUpperCase()
      : 'MMM DD, YYYY',
      adaptivePosition: false,
      showTodayButton: true,
      todayPosition: 'center'
  };
  public titleMaxLimit: boolean = false;
  public isChangeParentOrgUnitAccess = true;
  public hasRequiredError = false;
  public isFormSubmitted = false;
  public isParentOrgUnitChanged = false;
  public defaultSearchText = '';
  public parentOrgUnitPayload: any = {};
  public periodDetails: any;
  public startPeriodDateInMillis: any;
  public companyCodes: any;
  public companyCode: any;
  public currentOrganization: any;
  public currentParentOrganization: any;
  public isCompanyConfigNone = false;
  // public organizationData: any = {};
  public newOrganization: any;
  public parentOrganizationSame = false;
  public fromName: any = {};
  public changeOrgUnitObj: any = {};
  public menuObj: any = {};
  public hasChangeAccess = true;
  public showDownlineLeg = false;
  public orgUnitIndex: number = 0;
  public periodStartDateInMillis: any;
  public validationObj = {
    userMessage: '',
    state: ''
  };
  private defaultConfig: ModalOptions = {
    backdrop: true,
    ignoreBackdropClick: true
  };

  constructor( public modalService: BsModalService,
    public commonService: CommonService,
    private translate: TranslateService,
    private toastr: ToastrService,
    public planPeriodsService: PlanPeriodsService,
    public changeSponsorService: ChangeSponsorService
  ) {
    this.companyCodes = COMPANY_CODES;
      this.commonService.setHelpObj({
        header: this.getTranslationWithKey('CPR') || '',
        menuId: 'CPR',
        sections: [],
        lastSavedData: [],
        relatedLinks: [
          {
            label: this.getTranslationWithKey('FLP'),
            url: '/fieldsupport/distributorList/default'
          },
          {
            label: this.getTranslationWithKey('GLY'),
            url: '/genealogyHome/genealogy/default'
          }
        ]
      });
   }
   
  ngOnInit() {
    this.hasChangeAccess = this.commonService.hasFeatureAccess('Change Parent OrganizationUnit');
    const userInfo = this.commonService.getUserDetails();
    if (userInfo && userInfo.permissions && userInfo.permissions.details) {
      // const detailObj = userInfo.permissions.details.find((detailObj) => detailObj.code === 'CPR');
      // if (detailObj != undefined) {
      //   if (detailObj.code === 'CPR') {
      //     if (detailObj.permission.code === 'RAC') {
      //       this.isChangeParentOrgUnitAccess = false;
      //     }
      //   }
      // } else {
      //   this.isChangeParentOrgUnitAccess = false;
      // }
      this.isChangeParentOrgUnitAccess = true;
    }
    this.companyCode = this.commonService.getCompanyCode();
    this.isParentOrgUnitChanged = false;
    this.resetValidationErrorMessage();
    this.getPeriodDetails();
    /* MLM-2777 - start */
    const leadershipFunction = this.commonService.getGenealogyConfiguration();
    if (leadershipFunction) {
      this.isCompanyConfigNone = leadershipFunction.name === 'None';
    }
    // VCE - 3549 - "Period Close" check box to be selected By Default
    this.parentOrgUnitPayload.periodClose = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['organization'] && changes['organization'].currentValue) {
      this.defaultSearchText = changes['organization'].currentValue?.clientId;
      this.fromOrganizationSelected(changes['organization'].currentValue);
      // show movedownlineleg only for Leaders(BM,RM,TL Confirmed(Occasional))
      if (changes['organization'].currentValue.rank > 194) {
        this.showDownlineLeg = true;
        this.parentOrgUnitPayload.moveEntireDownlineLeg = true;
      } else {
        this.parentOrgUnitPayload.moveEntireDownlineLeg = false;
      }
    }
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  private getPeriodDetails() {
    this.planPeriodsService
      .getPeriod()
      .then(this.getPeriodDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  private getPeriodDetailsSH(response: any) {
    this.periodDetails = response;
    if (this.periodDetails) {
      this.checkPeriodClose();
    }
  }

  public checkPeriodClose() {
    if (this.parentOrgUnitPayload.periodClose) {
      this.startPeriodDateInMillis = moment(
        this.periodDetails.currentPeriod && this.periodDetails.currentPeriod.endDate
      )
        .add(1, 'days')
        .valueOf();
      if(['TMES', 'KSES'].includes(this.companyCode)) {
        this.parentOrgUnitPayload.effectiveDate = this.commonService.prepareBSEffectiveDateObj(this.startPeriodDateInMillis);
      } else {
        this.parentOrgUnitPayload.effectiveDate = this.commonService.prepareBSDateObj(this.startPeriodDateInMillis);
      }
    } else {
      // VCE-26904 - Effective Date should be Period Start Date instead of the current date if Period close not selected
      if (this.periodDetails.currentPeriod && this.periodDetails.currentPeriod.startDate) {
        this.periodStartDateInMillis = moment(this.periodDetails.currentPeriod.startDate);
        if(['TMES', 'KSES'].includes(this.companyCode)) {
          this.parentOrgUnitPayload.effectiveDate = this.commonService.prepareBSDateObj(this.currentDate.getTime());
        } else {
          this.parentOrgUnitPayload.effectiveDate = this.commonService.prepareBSDateObj(this.periodStartDateInMillis);
        }
      }
    }
  }

  private resetValidationErrorMessage() {
    this.validationObj = {
      userMessage: '',
      state: ''
    };
  }

  ngAfterViewInit() {
    this.orgParentUnitForm?.control?.valueChanges.subscribe(() => {
      if (this.orgParentUnitForm?.form?.invalid) {
        this.hasRequiredError = this.commonService.hasRequiredError(this.orgParentUnitForm?.form?.controls);
      } else {
        this.isFormSubmitted = false;
        this.hasRequiredError = false;
      }
    });
  }

  public fromOrganizationSelected(event: any) {
    this.parentOrgUnitPayload.fromParentOrgUnit = event;
    this.orgUnitIndex = event.orgUnitIndex;
    // show movedownlineleg only for Leaders(BM,RM,TL Confirmed(Occasional))
    if (this.parentOrgUnitPayload.fromParentOrgUnit.pinnedAs && this.parentOrgUnitPayload.fromParentOrgUnit.pinnedAs.rank > 194) {
      this.showDownlineLeg = true;
    }
    this.organizationTypeChange();
    this.organizationParentTypeChange();
  }

  public toOrganizationSelected(event: any) {
    this.parentOrgUnitPayload.toOrgUnit = event;
    if (this.parentOrgUnitPayload.toOrgUnit !== undefined) {
      this.newOrganization = this.parentOrgUnitPayload.toOrgUnit.organizationalUnit;
      this.setFullName(this.newOrganization);
    }
  }

  public clearToOrgStructureFilter(event: any) {
    this.parentOrgUnitPayload.toOrgUnit = null;
  }

  private setEffectiveDate() {
    this.parentOrgUnitPayload.effectiveDate = this.commonService.prepareBSDateObj(new Date().getTime());
  }

  public organizationTypeChange() {
    if (this.parentOrgUnitPayload.fromParentOrgUnit !== undefined && this.parentOrgUnitPayload.fromParentOrgUnit.organizationalUnit) {
      this.currentOrganization = this.parentOrgUnitPayload.fromParentOrgUnit.organizationalUnit;
    } else {
      this.currentOrganization = this.parentOrgUnitPayload.fromParentOrgUnit.organizationDetails[this.orgUnitIndex];
    }
    this.setFullName(this.currentOrganization);
  }

  public organizationParentTypeChange() {
    if (this.parentOrgUnitPayload.fromParentOrgUnit !== undefined && this.parentOrgUnitPayload.fromParentOrgUnit.organizationalUnit) {
      this.currentParentOrganization = this.parentOrgUnitPayload.fromParentOrgUnit.organizationalUnit;
    } else {
      this.currentParentOrganization = this.parentOrgUnitPayload.fromParentOrgUnit.organizationDetails[this.orgUnitIndex].parentOrganizationalUnit;
    }
    this.setFullName(this.currentParentOrganization);
  }

  public confimationPopUp() {
    const form = this.orgParentUnitForm?.form;
    let parentOrganizationUnit: any;
    this.isFormSubmitted = true;
    this.hasRequiredError = false;
    if (form?.invalid || !this.hasValidFormData()) {
      this.hasRequiredError = this.commonService.hasRequiredError(form?.controls) || !this.hasValidFormData();
    } else {
      this.isFormSubmitted = false;
      this.isParentOrgUnitChanged = false;
      if (this.parentOrgUnitPayload.fromParentOrgUnit && this.parentOrgUnitPayload.fromParentOrgUnit.organizationalUnit) {
        parentOrganizationUnit = this.parentOrgUnitPayload.fromParentOrgUnit.organizationalUnit;
      } else {
        parentOrganizationUnit = this.parentOrgUnitPayload.fromParentOrgUnit.organizationDetails[this.orgUnitIndex];
      }
      this.setFullName(parentOrganizationUnit);
      this.setFullName(this.parentOrgUnitPayload.toOrgUnit.organizationalUnit);
      if (this.parentOrgUnitPayload.fromParentOrgUnit) {
        const firstName = parentOrganizationUnit.firstName || '',
          lastName = parentOrganizationUnit.lastName || '';
        this.fromName.name = `${firstName} ${lastName}`;
      }
      const organizationData: any = {};
      organizationData['fromName'] = this.fromName.name;
      organizationData['orgUnitLbl'] = this.getTranslationWithKey('organization_parent_unit');
      organizationData['currentOrgUnitName'] = parentOrganizationUnit.orgUnitName;
      if (parentOrganizationUnit && parentOrganizationUnit.parentOrganizationalUnit) {
        organizationData['parentOrgUnitName'] = parentOrganizationUnit.parentOrganizationalUnit.orgUnitName;
      } else {
        organizationData['parentOrgUnitName'] = parentOrganizationUnit.orgUnitName;
      }
      organizationData['currentOrganization'] = this.currentOrganization;
      organizationData['newOrganization'] = this.newOrganization;
      organizationData['currentParentOrganization'] = this.currentParentOrganization;
      const initialState = {
        context: {
          isFrom: 'OrganizationChange',
          data: organizationData
        }
      };

      const modalRef: BsModalRef = this.modalService.show(ChangeParentOrganizationConfirmationModalComponent, {
        ...this.defaultConfig,
        initialState,
        class: 'modal-dialog change-sponsor-reg-ter-modal'
      });

      // Handle modal close event
      modalRef.content?.closeModal.subscribe((result: any) => {
        if (result) {
          this.changeParentOrganization(result);
        }
      });
    }
  }

  public changeParentOrganization(result: any) {
    let effectiveDate: any;
    if (this.parentOrgUnitPayload.periodClose) {
      effectiveDate = this.startPeriodDateInMillis;
    } else {
      effectiveDate = this.periodStartDateInMillis;
    }
    if (result === 'confirmed') {
      const payload = {
        comments: this.parentOrgUnitPayload.comments,
        effectiveDate: effectiveDate,
        periodClose: !!this.parentOrgUnitPayload.periodClose,
        // moveEntireDownlineLeg: !!this.parentOrgUnitPayload.moveEntireDownlineLeg
      };
      this.changeSponsorService
        .changeParentOrganization(
          payload,
          this.parentOrgUnitPayload.fromParentOrgUnit?.clientId,
          this.parentOrgUnitPayload.toOrgUnit.organizationalUnit.orgUnitId
        )
        .then(this.successHandler.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    }
  }

  private successHandler(result: any) {
    if (this.parentOrgUnitPayload.periodClose) {
      this.parentOrgUnitPayload.toOrgUnit = this.parentOrgUnitPayload.toOrgUnit;
    } else {
      this.parentOrgUnitPayload.toOrgUnit = result;
    }
    this.commonService.setUpdateChangeParentOrgUnitList(result);
    this.resetValidationErrorMessage();
    this.isParentOrgUnitChanged = true;
    this.toastr.success(this.getTranslationWithKey('operation_success'), this.getTranslationWithKey('success'));
  }

  private hasValidFormData() {
    this.parentOrganizationSame = false;
    let organization: any;
    if (this.parentOrgUnitPayload.fromParentOrgUnit && this.parentOrgUnitPayload.fromParentOrgUnit.organizationalUnit) {
      organization = this.parentOrgUnitPayload.fromParentOrgUnit.organizationalUnit;
    } else {
      organization = this.parentOrgUnitPayload.fromParentOrgUnit.organizationDetails[this.orgUnitIndex];
    }
    const cond =
      organization &&
      this.parentOrgUnitPayload.toOrgUnit &&
      organization.parentOrgUnit !== this.parentOrgUnitPayload.toOrgUnit.organizationalUnit.orgUnitId;
    if (
      organization &&
      this.parentOrgUnitPayload.toOrgUnit &&
      organization.parentOrgUnit == this.parentOrgUnitPayload.toOrgUnit.organizationalUnit.orgUnitId
    ) {
      this.parentOrganizationSame = true;
    }
    return cond;
  }

  private setFullName(organization: any) {
    if (organization) {
      const firstName = organization.orgUnitName || '';
      organization.name = `${firstName}`;
    }
  }

  public close() {
    this.isParentOrgUnitChanged = false;
    this.closeSlider.emit();
  }

  public clearOrgStructureFilter() {
    const effDate = this.parentOrgUnitPayload.effectiveDate;
    this.currentOrganization = null;
    this.parentOrgUnitPayload = {};
    this.parentOrgUnitPayload.effectiveDate = effDate;
    // VCE - 3549 - "Period Close" check box to be selected By Default
    this.parentOrgUnitPayload.periodClose = true;
    this.showDownlineLeg = false;
    this.parentOrgUnitPayload.moveEntireDownlineLeg = true;
    this.checkPeriodClose();
  }

  public titleCommentsValidation(e: any) {
    this.titleMaxLimit = e.target.value.length == 100;
  }
}
